/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const MagnifyingGlassOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.44 16.44 21 21m-2.25-10.12c0 4.34-3.53 7.87-7.87 7.87-4.35 0-7.88-3.53-7.88-7.87C3 6.53 6.53 3 10.88 3c4.34 0 7.87 3.53 7.87 7.88z"
})));
// Fill
const MagnifyingGlassFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M16.52 10.89c0 1.12-.33 2.2-.95 3.13s-1.49 1.65-2.52 2.07c-1.03.43-2.16.54-3.25.32s-2.1-.75-2.88-1.54c-.79-.78-1.32-1.79-1.54-2.88s-.11-2.22.32-3.25c.42-1.03 1.15-1.9 2.07-2.52.93-.62 2.01-.95 3.13-.95 1.49 0 2.92.59 3.97 1.65a5.583 5.583 0 0 1 1.65 3.97zm5.03 10.66a.75.75 0 0 1-1.06 0l-4.05-4.06a8.606 8.606 0 0 1-6.13 2.01 8.6 8.6 0 0 1-5.8-2.78 8.664 8.664 0 0 1-2.28-6.03c.05-2.23.96-4.35 2.53-5.93a8.691 8.691 0 0 1 5.93-2.53 8.7 8.7 0 0 1 6.03 2.27 8.644 8.644 0 0 1 2.78 5.81c.15 2.23-.57 4.42-2 6.13l4.05 4.05a.776.776 0 0 1 .22.53.776.776 0 0 1-.22.53zM10.9 18.02a7.138 7.138 0 0 0 6.58-4.4c.54-1.3.68-2.73.4-4.12a7.023 7.023 0 0 0-1.95-3.64c-.99-1-2.26-1.68-3.64-1.95-1.39-.28-2.82-.14-4.12.4s-2.42 1.45-3.2 2.63a7.138 7.138 0 0 0-1.2 3.95c0 1.89.75 3.7 2.09 5.04s3.15 2.09 5.04 2.09z"
})));
// DuoTone
const MagnifyingGlassDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M10.88 18.75c4.34 0 7.87-3.53 7.87-7.87 0-4.35-3.53-7.88-7.87-7.88C6.53 3 3 6.53 3 10.88c0 4.34 3.53 7.87 7.88 7.87z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M16.44 16.44 21 21m-2.25-10.12c0 4.34-3.53 7.87-7.87 7.87-4.35 0-7.88-3.53-7.88-7.87C3 6.53 6.53 3 10.88 3c4.34 0 7.87 3.53 7.87 7.88z"
})));
/**
  Icon MagnifyingGlassIcon in system group
*/
export const MagnifyingGlassIcon = createIcon('MagnifyingGlassIcon', 'magnifying-glass', 'system', MagnifyingGlassOutline, MagnifyingGlassFill, MagnifyingGlassDuotone, "0 0 24 24");